var _tspan;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgOutlineMobileSeven = function SvgOutlineMobileSeven(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 109"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "outline-mobile-seven_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 20211",
    transform: "translate(-42 371)",
    style: {
      fill: "none"
    },
    d: "M0 0h72v109H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 213",
    transform: "translate(42 -371)",
    style: {
      clipPath: "url(#outline-mobile-seven_svg__a)"
    }
  }, /*#__PURE__*/React.createElement("text", {
    "data-name": 7,
    transform: "translate(-26 455)",
    style: {
      stroke: "currentColor",
      strokeWidth: 4,
      fontSize: 70,
      fontFamily: "Sarabun-Bold,Sarabun",
      fontWeight: 700,
      letterSpacing: "-.1em",
      fill: "none"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "7")))));
};

export default SvgOutlineMobileSeven;